import { lazy, useCallback, useState } from 'react';
import { Nav } from '@/components/nav/Nav';
import { Loader } from '@/components/chrome/Loader';
import { Grain } from '@/components/chrome/Grain';
import { Cursor } from '@/components/chrome/Cursor';
import { SmoothScroll } from '@/components/chrome/SmoothScroll';
import { HudRail } from '@/components/chrome/HudRail';
import { LazySection } from '@/components/chrome/LazySection';
import { Footer } from '@/components/footer/Footer';
import { Intro } from '@/sections/Intro/Intro';

const Work = lazy(() => import('@/sections/Work/Work').then((m) => ({ default: m.Work })));
const Building = lazy(() =>
  import('@/sections/Building/Building').then((m) => ({ default: m.Building })),
);
const Research = lazy(() =>
  import('@/sections/Research/Research').then((m) => ({ default: m.Research })),
);
const Lab = lazy(() => import('@/sections/Lab/Lab').then((m) => ({ default: m.Lab })));
const About = lazy(() => import('@/sections/About/About').then((m) => ({ default: m.About })));
const Writing = lazy(() =>
  import('@/sections/Writing/Writing').then((m) => ({ default: m.Writing })),
);
const Contact = lazy(() =>
  import('@/sections/Contact/Contact').then((m) => ({ default: m.Contact })),
);

export default function App() {
  const [ready, setReady] = useState(false);
  // Stable identity: `Loader`'s effect depends on this, and a fresh function
  // each render would restart the count.
  const onLoaderDone = useCallback(() => setReady(true), []);

  return (
    <>
      <a
        href="#intro"
        className="bg-acid text-void focus:not-sr-only sr-only focus:fixed focus:top-4 focus:left-4 focus:z-110 focus:px-4 focus:py-2 focus:font-mono focus:text-xs"
      >
        Skip to content
      </a>

      <Loader onDone={onLoaderDone} />
      <Grain />
      <Cursor />
      <SmoothScroll />
      <HudRail />

      <Nav />

      <main id="main">
        <Intro ready={ready} />
        <LazySection id="work" Component={Work} />
        <LazySection id="building" Component={Building} />
        <LazySection id="research" Component={Research} />
        <LazySection id="lab" Component={Lab} />
        <LazySection id="about" Component={About} />
        <LazySection id="writing" Component={Writing} />
        <LazySection id="contact" Component={Contact} />
      </main>

      <Footer />
    </>
  );
}
